import * as Yup from 'yup'
import { editPlayerSchema } from '../../profile/player'
import { NAME_FORMAT_REGEX, NAME_FORMAT_MESSAGE } from '../../../ts-utils'

/**
 * Build the roster add/edit validation schema. The shared profile schema
 * (all-optional personal fields) plus the fields the legacy roster form makes
 * mandatory — first name, last name, jersey number, position — and, when the
 * roster requires it, email. Number must be an integer in 0..999 (matches the
 * legacy `playerForm` min/max).
 *
 * `requireEmail` mirrors the roster's `require_email` flag: when true the email
 * field is mandatory (and still format-checked); otherwise it stays optional
 * (format-checked only when present, per the shared profile schema).
 */
export const makeRosterPlayerSchema = (requireEmail = false) =>
  editPlayerSchema.shape({
    firstName: Yup.string()
      .trim()
      .matches(NAME_FORMAT_REGEX, {
        message: NAME_FORMAT_MESSAGE,
        excludeEmptyString: true,
      })
      .required('First name is required'),
    lastName: Yup.string()
      .trim()
      .matches(NAME_FORMAT_REGEX, {
        message: NAME_FORMAT_MESSAGE,
        excludeEmptyString: true,
      })
      .required('Last name is required'),
    playerNumber: Yup.string()
      .trim()
      .required('Player number is required')
      .matches(/^\d+$/, 'Player number must be a whole number')
      .test(
        'in-range',
        'Player number must be between 0 and 999',
        (v) => v === undefined || (Number(v) >= 0 && Number(v) <= 999)
      ),
    positionId: Yup.string().trim().required('Position is required'),
    email: requireEmail
      ? Yup.string()
          .trim()
          .email('Enter a valid email address')
          .required('Email is required')
      : editPlayerSchema.fields.email,
  })

/** Default roster schema (email optional). Kept for back-compat callers/tests. */
export const rosterPlayerSchema = makeRosterPlayerSchema(false)
